import { take, put, call, fork } from "redux-saga/effects"
import { authRequest } from "src/engine/modules/authRequest"
import get from "lodash/get"
import { REQUESTED_VALIDATE } from "../actions/types"
import {
  requestValidateSuccess,
  requestValidateError,
} from "../actions/creators"

function* request(action) {
  const plan = get(action, `config.plan`)
  if (plan) {
    try {
      const response = yield call(authRequest, {
        url: `/plans/${plan}/validate`,
      })

      yield put(requestValidateSuccess(action, response))
    } catch (error) {
      yield put(requestValidateError(action, error))
    }
  }
}

export default function* requestSaga() {
  while (true) {
    const action = yield take(REQUESTED_VALIDATE)
    yield fork(request, action)
  }
}
